import { WSElement, WSTableCell } from "@wingspanhq/fe-component-library";
import { queriesPayeeEngagements } from "@query";

interface ContractorsCountCellProps {
  engagementId: string;
}

export function ContractorsCountCell({
  engagementId
}: ContractorsCountCellProps) {
  // Server-side count: ask for a single row and read the envelope total, the v3
  // twin of v1's `page[size]=1` + `x-ws-list-size` header.
  const queryEngagements =
    queriesPayeeEngagements.listPayeeEngagementsByPayer.useQuery(
      {
        filter: { engagementId: { eq: engagementId } },
        page: { size: 1 }
      },
      { retry: false }
    );

  const count = queryEngagements.data?.pagination?.totalSize;

  return queryEngagements.isInitialLoading ? (
    <WSElement shimmer>Loading</WSElement>
  ) : (
    <WSTableCell text={`${count ?? "-"}`} />
  );
}
